import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import './index.css';
import Homepage from './containers/HomePage/Homepage';
import Header from './components/Header';
import Footer from './components/Footer';
import Terms from './components/terms';
import Privacy from './components/privacy';
import { Helmet } from 'react-helmet'
import PageNotFound from './containers/pageNotFound';
import DataDeletion from './components/dataDel';
import AccountDeletion from './components/accountDel';

function App() {
	return (
		<Router>
			<div className="w-full items-center flex flex-col bg-sky-50">
				{/* <Header /> */}
				<Helmet>
					<title>Swop</title>
				</Helmet>
				<main className="w-full">
					<Routes>
						<Route path="/" element={<Homepage />} />
						<Route path="/terms" element={<Terms />} />
						<Route path="/privacy" element={<Privacy />} />
						<Route path="/data" element={<DataDeletion />} />
						<Route path="/account" element={<AccountDeletion />} />
						<Route path='*' element={<PageNotFound />} />
					</Routes>
				</main>
				<Footer />
			</div>
		</Router>
	);
}

export default App;
